import React, {Component} from "react";
import {request} from "../../helper/APIUtils";
import {showAxiosError} from "../../helper/helper";
import AceEditor from "react-ace";
import "ace-builds/src-min-noconflict/ext-language_tools";
import "ace-builds/src-min-noconflict/mode-mysql";
import "ace-builds/src-min-noconflict/theme-tomorrow";
import Alert from "react-s-alert";
import Select from "../../local_node_modules/react-select";
import {Collapse} from "reactstrap";
import Swal from 'sweetalert2';
import {isValidERPOutboxPyld} from "../../common/componentValidation";
import {uuidGenerator, wsSend} from "./erpHelper";
class ConnectorQueryExecutor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [],
            query: "",
            queryResult: null,
            activeIndex:0,
            tabList:[],
            sqlList : [],
            collapse:{
                generalSqlList:false,
                individualSqlList: false,
                lastExecutedSqlList:true
            }
        };
    }
    componentDidMount() {
        this.addNewTab();
        this.fetchConnectorQuery();
    }

    fetchConnectorQuery = async () =>{
        let params = {
            url: `/connector/getAllConnectorAndCustomer/`,
            method: "get"
        };
        try{
            const response = await request(params);
            let{connectionInfo,queries,individualSqlList,lastExecutedSqlList} = response.data;
            console.log("connectionInfo",connectionInfo);

            if(connectionInfo.connectionType === "WEBSOCKET"){
                this.listenWebSocket(connectionInfo.ownerIp)
            }

            individualSqlList = individualSqlList.map(value=>{
                return {
                    recordId: value[0],
                    customerId: value[1],
                    branchId: value[2],
                    queryType: value[3],
                    queryContent: value[4],
                    branchName: value[5],
                }
            })
            this.setState({queries,individualSqlList,connectionInfo,lastExecutedSqlList})

        }catch(error){
            showAxiosError(error);
        }
    }

    listenWebSocket = async (ip) =>{
        let self = this;
        ip= ip + "/websocket/chat";
        const ws = new WebSocket(ip);

        this.setState({ws});

        ws.onopen = () => {
            console.log("connected");
            this.setState({connected:true});
        }

        // listen to data sent from the websocket server
        ws.onmessage = evt => {
            console.log("veri geldi",evt.data);
            let {queryType,rows,uuid} = JSON.parse(evt.data)
            rows = JSON.parse(rows);
            console.log("rows",rows);
            if(queryType == "ERROR" && rows && rows[0].error){
                Alert.error(rows[0].error, {
                    position: 'bottom-right',
                    effect: 'stackslide',
                    timeout: 3000
                });
                this.setState({searching:false})
            } else if(queryType == "specificQuery" && rows != null){
                console.log("veri geldi");
                const {activeIndex,tabList} = this.state;
                const currentTable = tabList[activeIndex];

                Alert.success('Sorgu Çalıştı!', {
                    position: 'bottom-right',
                    effect: 'jelly',
                    timeout: 3000
                });
                self.setState({queryContent: rows});
                let cols = [];
                if(rows[0]!=null){
                    Object.keys(rows[0]).map(m => {
                        cols.push(m);
                    });
                    currentTable.cols =cols;
                    currentTable.queryContent =rows;
                    self.setState({currentTable});
                }else{
                    Alert.error("Sorgunun cevabı boş", {
                        position: 'bottom-right',
                        effect: 'jelly',
                        timeout: 3000
                    });
                }


            }
        }

        ws.onclose = () => {
            console.log("disconnected");
            self.listenWebSocket(self.state.connectionInfo.ownerIp)
            this.setState({connected:false});
        }
    }
    executeQuery = async () => {
        let self = this;
        const {activeIndex,tabList} = this.state;
        const currentTable = tabList[activeIndex];
        let isValid = self.validation();
        if (isValid){
            try{
                const response = await request({
                    method: "post",
                    url: "/connector/specificQuery",
                    data: currentTable.query
                });
                if (response && response.data) {
                    Alert.success('Sorgu Çalıştı!', {
                        position: 'bottom-right',
                        effect: 'jelly',
                        timeout: 3000
                    });
                    self.setState({queryContent: response.data});
                    let cols = [];
                    Object.keys(response.data[0]).map(m => {
                        cols.push(m);
                    });
                    currentTable.cols =cols;
                    currentTable.queryContent =response.data;
                    self.setState({currentTable});
                }
            }catch (error){
                showAxiosError(error);
            }
        }

    }

    executeQueryWs = () => {
        let self = this;
        const {activeIndex,tabList} = this.state;
        const currentTable = tabList[activeIndex];
        let isValid = self.validation();
        if (isValid){
            try{
                const {connectionInfo,ws} = this.state;
                wsSend(connectionInfo,ws,currentTable.query,"specificQuery")
            }catch (error){
                showAxiosError(error);
            }
        }

    }

    validation = () =>{
        const {activeIndex,tabList} = this.state;
        const currentTable = tabList[activeIndex];
        let query = currentTable.query.trim().toLowerCase();
        if(query == ""){
            Alert.warning('Sorgu Boş Olamaz!', {
                position: 'bottom-right',
                effect: 'jelly',
                timeout: 3000
            });
            return false;
        }
        if ((query.includes("update") || query.includes("delete")) && !query.includes("where")) {
            Alert.error('Where koşulu olmadan bu sorguyu çalıştırmamalısın!', {
                position: 'bottom-right',
                effect: 'jelly',
                timeout: 3000
            });
            return false;
        }
        if (query.includes("drop") || query.includes("truncate")) {
            Alert.error('Sorguda Drop yada Truncate Komutu var!!!!', {
                position: 'bottom-right',
                effect: 'jelly',
                timeout: 3000
            });
            return false;
        }
        return true;
    }

    randomUuid = () =>{
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }
    addNewTab = () =>{
        let {tabList} = this.state;
        let newTab ={
            title:`Sorgu ${tabList.length+1}`,
            cols:null,
            queryContent:null,
            selectedErp:"",
            query:""
        }
        tabList.push(newTab);
        this.setState({tabList});
    }
    closeTab = (index) =>{
        this.changeTab(index-1);
        let {tabList} = this.state;
        if (index > -1) {
            tabList.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.setState({tabList});
    }
    changeTab = (index,e) =>{
        let{activeIndex,sqlList,tabList,queries,individualSqlList,lastExecutedSqlList} = this.state;
        activeIndex = index;
        const activeTab = tabList[activeIndex];
        sqlList = queries.filter(connection =>{
            return queries.erpType == activeTab.selectedErp
        });
        sqlList.sort(this.compare);
        this.setState({activeIndex});
        if(e && e.detail == 2){
            const{tabList} = this.state;
            tabList[activeIndex].title = prompt("Başlık Adı", `${tabList[activeIndex].title}`);
            this.setState({tabList});
        }
        this.setState({sqlList,individualSqlList,lastExecutedSqlList});
    }

    handleKeyDown = (event)=>{
        let charCode = String.fromCharCode(event.which).toLowerCase();
        if((event.ctrlKey || event.metaKey) && event.keyCode == 13){
            const {connectionInfo} = this.state;
            if(connectionInfo.connectionType === "WEBSOCKET"){
                this.executeQueryWs()
            }else{
                this.executeQuery()
            }

        }

    }

    updateSql = async () =>{
        let self = this;
        const{activeIndex,tabList} = this.state;
        const activeTab = tabList[activeIndex];
        let connectorQuery = {
            recordId : activeTab.recordId,
            content: activeTab.query
        }
        tryName: try{
            if(connectorQuery.recordId==null) break tryName;
            let params = {
                method: "post",
                url: activeTab.type =="general" ? "/connector/updateConnectorQuery":"/connector/updateCustomerConnectorQuery",
                data: connectorQuery
            }
            const response = await request(params);
            if (response && response.data) {
                Alert.success('Sorgu Güncellendi!', {
                    position: 'bottom-right',
                    effect: 'jelly',
                    timeout: 3000
                });
            }
        }catch (error){
            showAxiosError(error);
        }
    }

    listOnClick = (e,type,id) =>{
        const {queries,individualSqlList,lastExecutedSqlList,tabList,activeIndex} = this.state;
        let activeTab = tabList[activeIndex];
        let query = ""
        let sortIndex;
        if(type=="general"){
            activeTab.type ="general";
            let sqlList = queries.filter(connection =>{
                return connection.erpType == activeTab.selectedErp
            });
            sqlList.sort(this.compare);
            sortIndex = sqlList.findIndex(data => data.recordId == id);
            activeTab.query = sqlList[sortIndex].content;
            activeTab.recordId = sqlList[sortIndex].recordId;
            activeTab.queryType = sqlList[sortIndex].queryType;
            activeTab.index = sortIndex;
        }else if(type=="individual"){
            activeTab.type ="individual";
            sortIndex = individualSqlList.findIndex(data => data.branchId == id);
            activeTab.query = individualSqlList[sortIndex].queryContent;
            activeTab.recordId = individualSqlList[sortIndex].recordId;
            activeTab.queryType = individualSqlList[sortIndex].queryType;
            activeTab.index = sortIndex;
        }else if(type=="last"){
            activeTab.type ="last";
            sortIndex = lastExecutedSqlList.findIndex(data => data.recordId == id);
            activeTab.query = lastExecutedSqlList[sortIndex].query;
            activeTab.index = sortIndex;
        }
        activeTab.selectedItem = sortIndex;
        tabList[activeIndex] = activeTab;
        this.setState({tabList})
    }

    erpChange = (e) =>{
        const {tabList,activeIndex} = this.state;
        const activeTab = tabList[activeIndex];
        activeTab.selectedErp = e.value;
        activeTab.index = null;
        tabList[activeIndex] = activeTab;
        let {queries} = this.state;
        let sqlList = [];
        sqlList = queries.filter(connection =>{
            return connection.erpType == e.value
        });
        sqlList.sort(this.compare);
        this.setState({tabList,sqlList});
    }
    compare = ( a, b ) => {
        if ( a.queryType < b.queryType ){
            return -1;
        }
        if ( a.queryType > b.queryType ){
            return 1;
        }
        return 0;
    }
    onClickTr = (e) =>{
        let activeItem = document.getElementsByClassName("table-info")[0];
        if(activeItem) activeItem.classList.remove("table-info");
        if(e.target.nodeName=="TR"){
            e.target.classList.add("table-info");
        }else if(e.target.nodeName == "TD"){
            e.target.parentElement.classList.add("table-info");
        }
    }
    clearActiveTab = () =>{
        const {tabList,activeIndex} = this.state;
        let activeTab = tabList[activeIndex];
        activeTab.index = null;
        activeTab.selectedErp = ""
        activeTab.query = ""
        tabList[activeIndex] = activeTab;
        this.setState({tabList});
    }
    getActiveTab = () =>{

    }
    render() {
        //TODO: Tablı yapıya geçilip RAW halininde gösterilmesi
        let btnClass = "btn btn-secondary"
        const {tabList,activeIndex,sqlList,individualSqlList,lastExecutedSqlList,collapse,connectionInfo} = this.state;
        const activeTab = tabList[activeIndex];
        return (
            <div>
                <div className="connector-query-editor-header">
                    <div className="header-left">
                        <button onClick={this.addNewTab} type="button" className="btn btn-info">
                            <i className="fas fa-plus"></i>
                        </button>
                        {sqlList && sqlList.length>0 &&
                            <button onClick={()=>{this.clearActiveTab()}} type="button" className="btn btn-danger">
                                <i className="fas fa-trash"></i>
                            </button>
                        }
                        {tabList && tabList.length>0 &&
                        <button style={activeIndex == 0 ?{background:"#14c3ff"}:{}} onClick={e=>this.changeTab(0,e)} type="button" className="btn btn-secondary"><i className="fas fa-folder"></i>
                            <span>{tabList[0].title}</span>
                        </button>
                        }
                        {tabList && tabList.length>0 && tabList.map((tab,index)=>{
                            if(index!=0){
                                return(
                                    <div style={activeIndex == index ?{background:"#14c3ff"}:{}} type="button" key={index} className="editor-btn">
                                        <div onClick={e=>this.changeTab(index,e)}>
                                            <i className="fas fa-folder-open"></i><span>{tab.title}</span>
                                        </div>
                                        <span onClick={e => this.closeTab(index)}>
                                            <i className="fas fa-times"></i>
                                        </span>
                                    </div>
                                );
                            }else return null
                        })}
                    </div>
                    <div className="header-right">
                        <button type="button" onClick={(e) => {
                            if(connectionInfo.connectionType === "WEBSOCKET"){
                                this.executeQueryWs()
                            }else{
                                this.executeQuery()
                            }
                        }} className="btn btn-primary"><i className="fas fa-play"></i>
                            <span> Sorguyu Çalıştır</span>
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <div className="card" style={{marginTop:"5px",cursor:"pointer"}}>
                            <div className="list-group-item" style={{background:"rgba(0,0,0,.03)"}} onClick={e=>{
                                let collapse = this.state.collapse;
                                collapse.lastExecutedSqlList = !collapse.lastExecutedSqlList;
                                this.setState({collapse});
                            }}>
                                Son Çalıştırılan Sorgular
                            </div>
                            {activeTab &&
                                <Collapse isOpen={collapse.lastExecutedSqlList}>
                                    {lastExecutedSqlList && lastExecutedSqlList.map((sql,index) =>(
                                        <div key = {index}  onClick={e=>this.listOnClick(e,"last",sql.recordId)}
                                             className={activeTab.type == "last" && activeTab.index == index ? "list-group-item active":"list-group-item"}>

                                            <p style={{marginBottom:'5px'}}>{sql.branchName} ({sql.dateTime})</p>
                                            <p style={{marginBottom:0}}> {sql.queryType}</p>
                                        </div>
                                        // <ul key = {index} className="list-group">
                                        //     <li style={{cursor:"pointer"}} onClick={e=>this.listOnClick(e,"last",sql.recordId)} key={sql.recordId}
                                        //         className={activeTab.type == "last" && activeTab.index == index ? "list-group-item active":"list-group-item"}>
                                        //         {sql.queryType}({sql.branchName}){sql.dateTime}
                                        //     </li>
                                        // </ul>
                                    ))}

                                </Collapse>
                            }

                        </div>
                    </div>
                    {activeTab &&
                        <div className="col-md-10" onKeyDown={this.handleKeyDown}
                             tabIndex="0">
                            <AceEditor
                                aria-label="query editor input"
                                mode="mysql"
                                theme="tomorrow"
                                name="editor"
                                fontSize={16}
                                autoScrollEditorIntoView={true}
                                maxLines= {50}
                                minLines={20}
                                width="100%"
                                showPrintMargin={false}
                                showGutter
                                highlightActiveLine={true}
                                placeholder={"Sql sorgunuzu buraya yazın"}
                                editorProps={{ $blockScrolling: true }}
                                setOptions={{
                                    enableBasicAutocompletion: true,
                                    enableLiveAutocompletion: true,
                                    enableSnippets: true,
                                }}
                                value={activeTab.query}
                                onChange={(e)=>{
                                    activeTab.query = e;
                                    tabList[activeIndex] = activeTab;
                                    this.setState({tabList});
                                }}
                                showLineNumbers
                            />
                        </div>
                    }


                </div>

                <div className="row" style={{overflow:'auto',marginTop:"20px"}}>
                    {
                        activeTab &&
                        <table className="styled-table" style={{fontSize:"12px"}}>
                            <thead>
                                <tr>{activeTab.cols && activeTab.cols.map((m,index) =>
                                    <th key={index}>{m}</th>)}
                                </tr>
                            </thead>
                            <tbody>
                            {activeTab.queryContent && activeTab.queryContent.length > 0 && activeTab.queryContent.map((m,index) =>
                                <tr key={index} onClick={e =>this.onClickTr(e)}>
                                    {
                                        Object.values(m).map((v,index) => <td key={index}>{v}</td>)
                                    }
                                </tr>)}
                            </tbody>
                        </table>
                    }
                </div>
            </div>
        );
    }
}

export default ConnectorQueryExecutor;